import { EventAdapter, Resources } from "@validereinc/domain";
import {
  useDeleteOne,
  useGetList,
  useGetOne,
  useUpdateOne,
} from "./adapterUtils";

export const useGetOneEvent = useGetOne(EventAdapter.getOne, Resources.EVENT);

export const useListEvents = useGetList(EventAdapter.getList, Resources.EVENT);

export const useUpdateEvent = useUpdateOne(
  EventAdapter.updateOne,
  Resources.EVENT
);

export const useDeleteEvent = useDeleteOne(
  EventAdapter.deleteOne,
  Resources.EVENT
);
